import React, { useEffect, useState } from "react";
import Helmet from "../../components/Helmet";
import { ClipLoader } from "react-spinners";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../api/axiosInstance";

const Admin = () => {
  const [loading, setLoading] = useState(false);
  const [totalAdmins, setTotalAdmins] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(50);
  const [newCategory, setNewCategory] = useState("");
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    emp_code: "",
    name: "",
    email: "",
    mobile: "",
    semester: "",
    designation: "",
  });

  const [showModal, setShowModal] = useState(false);

  const handleAdd = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setErrors("");
    setFormData("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSaveAdmin = async () => {
    let newErrors = {};
    if (!formData.emp_code) newErrors.emp_code = "Employee ID required";
    if (!formData.name) newErrors.name = "Name required";
    if (!formData.email) newErrors.email = "Email required";
    if (!formData.mobile) newErrors.mobile = "Mobile is required";
    if (!formData.designation)
      newErrors.designation = "Designation is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setLoading(true);

      const res = await api.post("/admin/addAdmin", formData);

      toast.success("Admin added successfully");
      setShowModal(false);
      setFormData({
        emp_code: "",
        name: "",
        email: "",
        mobile: "",
        semester: "",
        designation: "",
      });

      fetchTotalAdmins();
    } catch (error) {
      console.error(error);
      toast.error("Failed to add admin");
    } finally {
      setLoading(false);
    }
  };

  const fetchTotalAdmins = async () => {
    try {
      setLoading(true);
      const res = await api.get("/admin/fetchAdmin");

      setTotalAdmins(res.data.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch admin users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTotalAdmins();
  }, [page]);

  return (
    <>
      <Helmet title="Admin User" />
      <ToastContainer position="top-center" autoClose={3000} />

      {loading && (
        <div className="full-page-loader">
          <ClipLoader size={60} />
        </div>
      )}

      <main className="app-main">
        <div className="app-content m-2">
          <div className="container-fluid">
            <div className="card mb-4">
              <div className="card-body">
                <div className="d-flex justify-content-end mb-3">
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleAdd}
                  >
                    Add New
                  </button>
                </div>

                <table className="table table-bordered table-hover">
                  <thead className="table-dark">
                    <tr>
                      <th style={{ width: "60px" }}>S.No</th>
                      <th>Employee ID</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Semester</th>
                      <th>Mobile</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {totalAdmins.length > 0 ? (
                      totalAdmins.map((admin, index) => (
                        <tr key={index}>
                          <td>{(page - 1) * pageSize + (index + 1)}</td>
                          <td>{admin.EMP_CODE}</td>
                          <td>{admin.NAME}</td>
                          <td>{admin.EMAIL}</td>
                          <td>{admin.SEMESTER}</td>
                          <td>{admin.MOBILE}</td>
                          <td>
                            {admin.STATUS === "1" ? "Active" : "Inactive"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {showModal && (
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Add New Admin</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                  />
                </div>

                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Employee ID</label>
                    <input
                      type="text"
                      className="form-control"
                      name="emp_code"
                      value={formData.emp_code}
                      onChange={handleChange}
                    />
                    {errors.emp_code && (
                      <small className="text-danger">{errors.emp_code}</small>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && (
                      <small className="text-danger">{errors.name}</small>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Mobile</label>
                    <input
                      type="text"
                      className="form-control"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                    {errors.mobile && (
                      <small className="text-danger">{errors.mobile}</small>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Semester</label>
                    <input
                      type="text"
                      className="form-control"
                      name="semester"
                      value={formData.semester}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Designation</label>
                    <input
                      type="text"
                      className="form-control"
                      name="designation"
                      value={formData.designation}
                      onChange={handleChange}
                    />
                    {errors.designation && (
                      <small className="text-danger">
                        {errors.designation}
                      </small>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleSaveAdmin}
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default Admin;
